import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './features/home/home.component';
import { QuienesSomosComponent } from './features/quienes-somos/quienes-somos.component';
import { SistemaGesvatecComponent } from './features/sistema-gesvatec/sistema-gesvatec.component';
import { EtiquetaComponent } from './features/etiqueta/etiqueta.component';
import { ProductosGestionadosComponent } from './features/productos-gestionados/productos-gestionados.component';
import { CertificadoComponent } from './features/certificado/certificado.component';
import { ClientesComponent } from './features/clientes/clientes.component';
import { SoporteComponent } from './features/soporte/soporte.component';
import { ContactoComponent } from './features/contacto/contacto.component';
import { LegalPageComponent } from './features/legal/legal-page.component';
import { VerificarCertificadoComponent } from './features/verificar-certificado/verificar-certificado.component';
import { TrazabilidadCertificadoComponent } from './features/trazabilidad-certificado/trazabilidad-certificado.component';

const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
  { path: 'quienes-somos', component: QuienesSomosComponent },
  { path: 'sistema-gesvatec', component: SistemaGesvatecComponent },
  { path: 'etiqueta', component: EtiquetaComponent },
  { path: 'certificado', component: CertificadoComponent },
  { path: 'productos-gestionados', component: ProductosGestionadosComponent },
  { path: 'clientes', component: ClientesComponent },
  { path: 'soporte', component: SoporteComponent },
  { path: 'contacto', component: ContactoComponent },
  { path: 'verify-certificate', component: VerificarCertificadoComponent },
  { path: 'certificate-traceability', component: TrazabilidadCertificadoComponent },
  { path: 'terminos-condiciones', component: LegalPageComponent, data: { key: 'terminos' } },
  { path: 'politica-privacidad', component: LegalPageComponent, data: { key: 'privacidad' } },
  { path: 'politica-cookies', component: LegalPageComponent, data: { key: 'cookies' } },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
